module.exports = __webpack_public_path__ + "static/media/design-img-1.3d4aa345.jpg";